import type { KeyboardEvent } from "react";

/**
 * Props for a text input inside one of `CardFormLayout`'s bordered shells —
 * the card cluster, or a standalone name / zip field. The shell owns the
 * border and focus ring, so the input itself has none. Shared with the
 * provider that supplies its own text inputs to the cluster; Stripe's iframes
 * read the same `cardInput` text style back as computed CSS instead.
 */
export const cardInputProps = {
  bg: "transparent",
  border: "0",
  outline: "none",
  px: "14px",
  textStyle: "cardInput",
  color: "fg.default",
  h: "52px",
  w: "100%",
  _placeholder: { color: "fg.muted" },
} as const;

/** Refuse anything but a digit at the key, leaving shortcuts and navigation alone. */
export const digitsOnly = (e: KeyboardEvent<HTMLInputElement>) => {
  if (e.metaKey || e.ctrlKey || e.key.length > 1) return;
  if (e.key < "0" || e.key > "9") e.preventDefault();
};
